import { render, staticRenderFns } from "./Indexation.vue?vue&type=template&id=0c1ad7c0&scoped=true&"
import script from "./Indexation.vue?vue&type=script&lang=ts&"
export * from "./Indexation.vue?vue&type=script&lang=ts&"
import style0 from "./Indexation.vue?vue&type=style&index=0&id=0c1ad7c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ad7c0",
  null
  
)

export default component.exports